/**
 * @author Kelnik
 *
 * ProgressGallery - Вывод информации для прогресса
 */

import Observer from 'common/scripts/observer';
import ScrollBy from 'components/scrollBy';
import tmplGallery from './templates/gallery.twig';
import tmplSlider from './templates/slider.twig';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class ProgressGallery {
    constructor() {
        this.containerSelector = '.j-progress-gallery';
        this.container = document.querySelector(this.containerSelector);
        this.gallerySelector = '.j-progress-gallery-content';
        this.sliderSelector = '.j-progress-gallery-slider';
        this.slideSelector = '.j-residential-slide';
        this.durationAnimate = 300;
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initScrollBy();
        this._bindEvents();
    }

    _initElements() {
        this.gallery = this.container.querySelector(this.gallerySelector);
        this.slider = this.container.querySelector(this.sliderSelector);
        this.isMobile = Utils.isBreakpoint(320, 959);
    }

    _initScrollBy() {
        this.scroll = new ScrollBy();
        this.scroll.init({speedAnimation: 600});
    }

    _bindEvents() {
        observer.subscribe('progress-year:change-month', (data) => {
            this._showContent();
            this._replaceGallery(data.month);
            this._replaceSlider(data);
            this._bindAfterAjax();
        });

        observer.subscribe('progress-year:before-month', () => {
            this._hideContent();
            this.scroll.scrollToElement(this.container);
        });

        observer.subscribe('scrollbyFinish', (name) => {
            if (name === 'scrollLoad') {
                observer.publish('progress-gallery:change-month', this.currentId);
            }
        });

        this._bindAfterAjax();
    }

    _bindAfterAjax() {
        this.slides = Array.from(this.container.querySelectorAll(this.slideSelector));

        this.slides.forEach((slide) => {
            slide.addEventListener('click', (event) => {
                event.preventDefault();

                this.scroll.scrollToElement(this.container, 'scrollLoad');
                this.currentId = slide.dataset.id;
                this._hideContent();
            });
        });
    }

    _replaceGallery(data) {
        Utils.clearHtml(this.gallery);
        this.gallery.insertAdjacentHTML('beforeend', tmplGallery(data));

        if (!this.isMobile) {
            this.datesValue = document
                .querySelector('.j-progress-years-split-date').querySelector('.slash-props__prop-ttl');

            this.datesValue.innerHTML = this.datesValue.innerHTML.split(',').join(',<br>');
        }
    }

    _replaceSlider(data) {
        Utils.clearHtml(this.slider);
        this.slider.insertAdjacentHTML('beforeend', tmplSlider(data));

        observer.publish('lazyLoad:refresh', this.slider);
        observer.publish('residential-list:refresh', this.slider, data.activeIndex);
    }

    _hideContent() {
        this.container.classList.add('is-hide');
    }

    _showContent() {
        this.container.classList.remove('is-hide');
    }
}

new ProgressGallery().init();
